import { useAuthContext } from 'noddi-web';

export const useIsCurrentUserGroupAnOrganization = () => {
  const { userData, currentUserGroupId } = useAuthContext();

  return !!userData?.user?.userGroups?.find((ug) => ug.id === currentUserGroupId)?.isOrganization;
};
